import React from 'react'

import './CreatingServiceLoader.scss'
import Backdrop from 'components/Backdrop'
import Loader from 'components/Loader'

export default function CreatingServiceLoader ({ isOpen }) {
  return isOpen && (
    <Backdrop>
      <Loader
        text='Agendando tu servicio'
        className='CreatingServiceLoader'
        />
    </Backdrop>
  )
}



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/CreatingServiceLoader/CreatingServiceLoader.js